// src/provider/GoogleMapsProvider.jsx
import PropTypes from "prop-types";
import { createContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

export const GoogleMapsContext = createContext(null);

// FIX: static libraries array
const MAP_LIBRARIES = ["maps", "marker", "places"]; 

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-maps-sdk",
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_API_KEY,
    libraries: MAP_LIBRARIES,      // FIXED
    version: "weekly"              // recommended
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

GoogleMapsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
